<template>
    <v-select
        ref="dropdownPartnerLocations"
        v-model="selected"
        :disabled="inFlight || !hasWebsiteInfo"
        :loading="inFlight || !hasWebsiteInfo"
        :label="label"
        :items="partnerList"
        :rules="rules"
        itemText="friendly"
        clearable
        dense
        hideDetails
        hideNoData
        outlined
        returnObject
    />
</template>

<script>
// Vuex
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'DropdownPartnerLocations',
    props: {
        value: {
            type: Object,
            required: false,
        },
        label: {
            type: String,
            required: false,
            default: 'Destination Location',
        },
        rules: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
    computed: {
        ...mapGetters( {
            hasWebsiteInfo: 'Website/hasInfo',
            partnerList: 'Inventory/partnerList',
        } ),
        ...mapState( {
            inFlight: ( state ) => state.Inventory.partneredLocations.inFlight,
        } ),
        selected: {
            get() {
                return this.value;
            },
            set( value ) {
                this.$emit( 'input', value ?? {} );
            },
        },
    },
    watch: {
        hasWebsiteInfo() {
            if ( this.hasWebsiteInfo ) {
                this.getPartners();
            }
        },
    },
    mounted() {
        this.getPartners();
    },
    methods: {
        async getPartners() {
            await this.$store.dispatch( 'Inventory/getPartneredLocations' );
        },
        reset() {
            this.$refs.dropdownPartnerLocations.reset();
        },
    },
};
</script>
